import React, { forwardRef } from "react";
import ButtonElement from "../../../../../common/ButtonElement";
import { UPDATE_TYPES, OCR_STATUS_TYPES } from "../dataUpdateConstants";
import { ReactComponent as Camera } from "../../../../../../assets/icons/camera.svg";
import { ReactComponent as Paperclip } from "../../../../../../assets/icons/paperclip.svg";
import { isMobile } from "react-device-detect";
import "./PersonalDataUpdateOcrActions.css";

const PersonalDataUpdateOcrActions = forwardRef(
  (
    {
      captureImageHandler,
      loading,
      uploadFileClickHandler,
      uploadFileChangeHandler,
      uploadedFile,
      ocrStatus,
      retryClickHandler,
      updateType,
      setOcrStatus,
    },
    ref
  ) => {
    const fileName = (
      <p className="font-weight-bold">
        Numele fişierului: {uploadedFile?.name}
      </p>
    );

    const uploadOrCaptureText = isMobile ? "Fotografiază" : "Încarcă";
    const uploadOrCaptureIcon = isMobile ? (
      <Camera className="ocr-update-icons" />
    ) : (
      <Paperclip className="ocr-update-icons" />
    );

    const renderActionButtons = (status) => {
      switch (status) {
        case OCR_STATUS_TYPES.DEFAULT:
          return (
            <div className="row justify-content-center mb-3">
              {!isMobile && (
                <div className="col-12 col-lg-auto mb-4 mb-lg-0 d-flex flex-column align-items-center">
                  <Camera className="ocr-update-icons" />
                  <ButtonElement
                    onClick={() =>
                      setOcrStatus((prevStatus) => ({
                        ...prevStatus,
                        type: OCR_STATUS_TYPES.CAPTURE,
                      }))
                    }
                    buttonText="Fotografiază"
                    disabled={loading}
                    spinWhenDisabled={updateType === UPDATE_TYPES.UPLOAD}
                  />
                </div>
              )}
              <div className="col-12 col-lg-auto d-flex flex-column align-items-center">
                {uploadOrCaptureIcon}
                <ButtonElement
                  onClick={() => uploadFileClickHandler()}
                  buttonText={uploadOrCaptureText}
                  disabled={loading}
                  spinWhenDisabled={updateType === UPDATE_TYPES.IMAGE}
                />
                <input
                  type="file"
                  ref={ref}
                  onChange={uploadFileChangeHandler}
                  style={{ display: "none" }}
                />
              </div>
            </div>
          );
        case OCR_STATUS_TYPES.CAPTURE:
          return (
            <div className="row justify-content-center align-items-end mb-3">
              <div className="col-12 col-lg-auto mb-4 mb-lg-0 d-flex flex-column align-items-center">
                <Camera className="ocr-update-icons" />
                <ButtonElement
                  onClick={captureImageHandler}
                  buttonText="Fotografiază"
                  disabled={loading}
                  spinWhenDisabled={updateType === UPDATE_TYPES.UPLOAD}
                />
              </div>
              <div className="col-12 col-lg-auto d-flex flex-column align-items-center">
                <ButtonElement
                  type="button"
                  buttonText="Înapoi"
                  light
                  onClick={retryClickHandler}
                  disabled={loading}
                  spinWhenDisabled={true}
                />
              </div>
            </div>
          );
        case OCR_STATUS_TYPES.ERROR:
          return (
            <>
              <h3 className="error mb-3">{ocrStatus.message}</h3>
              <div className="mb-3">
                <ButtonElement
                  type="button"
                  buttonText="Reîncearcă"
                  onClick={retryClickHandler}
                />
              </div>
            </>
          );
      }
    };

    return (
      <>
        {uploadedFile && fileName}
        {renderActionButtons(ocrStatus.type)}
      </>
    );
  }
);

export default PersonalDataUpdateOcrActions;
